const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const get = require('lodash.get');

const ContextComponent = require('../../../global/components/ContextComponent');

const style = require('../styles/ConditionReportModal.scss');
const copy = require('./conditionReportModalCopy.json');

class ConditionReportForm extends ContextComponent {
    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);

        this.state = {
            description: '',
            isLoading: false,
            isError: false,
        };
    }
    onChange(event) {
        this.setState({ description: event.target.value });
    }
    onSubmit(event) {
        const { isLoading, description } = this.state;
        let newState = {};

        if (description && !isLoading) {
            newState = {
                isLoading: true,
                isError: false,
            };
        } else if (!isLoading) {
            event.preventDefault();
            newState = {
                isError: true,
            };
        }
        this.setState(newState);
    }
    handleSuccess() {
        this.props.onSuccess();
    }
    render() {
        const { description, isError, isLoading } = this.state;
        const { user, item } = this.props;
        return (
            <div>
                <form
                    className={style.content}
                    method="post"
                    action="https://www.tfaforms.com/responses/processor"
                    target="conditionReportIframe"
                    onSubmit={this.onSubmit}
                >
                    <label className={style.label}>{copy.descriptionLabel}</label>
                    <textarea
                        className={style.textarea}
                        name="tfa_4"
                        value={description}
                        onChange={this.onChange}
                        title="Description"
                    />
                    {isError && <div className={style.error}>{copy.error}</div>}

                    <button
                        className={`button-primary button-large ${style.submit}`}
                        disabled={isLoading}
                    >
                        {isLoading ? copy.buttonSending : copy.buttonSend}
                    </button>

                    <input type="hidden" name="tfa_7" value={get(user, 'serviceId', '')} />
                    <input type="hidden" name="tfa_8" value={get(item, 'seller.serviceId', '')} />
                    <input type="hidden" name="tfa_1" value="" />
                    <input type="hidden" name="tfa_2" value="" />

                    <input
                        type="hidden"
                        name="tfa_3"
                        value={`Condition Report Request for - ${get(item, 'dibsReference', '')}`}
                    />
                    <input type="hidden" name="tfa_5" value={get(item, 'dibsReference', '')} />
                    <input type="hidden" name="tfa_6" value={get(item, 'title', '')} />
                    <input
                        type="hidden"
                        name="tfa_9"
                        value={get(item, 'pricing.totalAmount.amount', '')}
                    />

                    <input type="hidden" value="4605473" name="tfa_dbFormId" />
                    <input type="hidden" value="" name="tfa_dbResponseId" />
                    <input
                        type="hidden"
                        value="24b4b37b947816e393a8c548e4f1fed7"
                        name="tfa_dbControl"
                    />
                    <input type="hidden" value="2" name="tfa_dbVersionId" />
                    <input type="hidden" value="" name="tfa_switchedoff" />
                </form>
                <iframe
                    className="is-hidden"
                    name="conditionReportIframe"
                    onLoad={this.handleSuccess}
                />
            </div>
        );
    }
}

ConditionReportForm.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
    onSuccess: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
};

module.exports = Relay.createContainer(ConditionReportForm, {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                serviceId
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                dibsReference
                title
                firstPhotoWebPath(size: original)
                pricing {
                    totalAmount {
                        amount
                    }
                }
                seller {
                    serviceId
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/ConditionReportForm.jsx